import { RiDeleteBinLine, RiMore2Line, RiPencilLine } from '@remixicon/react';
import { useMemo } from 'react';
import { AgButton, AgSwitch } from 'src/components/ui';
import { AgDropdownItem, AgDropdownMenu } from 'src/components/ui/AgDropdownMenu';
import { GridColObj } from 'src/modules/grids';

type UseExpenseTypeColumnsProps = {
  onEdit: (row: any) => void;
  onToggleEnabled: (row: any) => void;
  onDelete: (row: any) => void;
};

export function useExpenseTypeColumns({ onEdit, onToggleEnabled, onDelete }: UseExpenseTypeColumnsProps) {
  return useMemo<GridColObj>(
    () => ({
      name: { headerName: 'Name', type: 'string', flex: 1 },
      receivablesAccount: {
        headerName: 'Receivables Account',
        type: 'string',
        // A relation object, not a column the server can sort or filter; search still matches its name.
        sortable: false,
        filterable: false,
        valueFormatter: (value) => value?.accountName,
        flex: 1,
      },
      payablesAccount: {
        headerName: 'Payables Account',
        type: 'string',
        sortable: false,
        filterable: false,
        valueFormatter: (value) => value?.accountName,
        flex: 1,
      },
      actions: {
        type: 'actions',
        headerName: '',
        disableExport: true,
        minWidth: 140,
        renderCell: ({ row }) => {
          const isActive = !!(row.isActivePayable || row.isActiveReceivable);

          return (
            <div className="flex w-full items-center justify-end gap-1">
              <AgSwitch size="sm" isSelected={!row.disabled} onChange={() => onToggleEnabled(row)} />
              <AgButton
                variant="ghost"
                size="icon-sm"
                shape="circle"
                excludeFromTabOrder
                onPress={() => onEdit(row)}
                isDisabled={row.disabled}
              >
                <RiPencilLine size={20} />
              </AgButton>
              <AgDropdownMenu
                size="icon-sm"
                icon={<RiMore2Line size={20} />}
                variant="ghost"
                excludeFromTabOrder
                items={
                  <AgDropdownItem
                    icon={<RiDeleteBinLine size={20} />}
                    destructive
                    isDisabled={isActive}
                    onAction={() => onDelete(row)}
                  >
                    Delete
                  </AgDropdownItem>
                }
              />
            </div>
          );
        },
      },
    }),
    [onEdit, onToggleEnabled, onDelete]
  );
}
